import en from './strings.en';

const ru = {
    payedTitle: 'Показать ещё {{count}}',
    needPayTitle: 'Перейти к оплате и показать ещё',
    companies: {
        zero: 'фирм',
        one: 'фирму',
        few: 'фирмы',
        many: 'фирм',
        other: 'фирм'
    }
};

export default { ru, en: { ...ru, ...en} };
